import FetchHelpers from 'utils/FetchHelpers';
import { apiRoutes } from 'routes';

export default {
  create(slug, attrs) {
    const url = apiRoutes.buyersRealEstateAgentReferralPath(slug);

    return FetchHelpers.post(url, attrs);
  },
};



// WEBPACK FOOTER //
// ./src/repositories/buyer/RealEstateAgentReferralRepository.js